module.exports = __webpack_public_path__ + "img/bz.10078a02.svg";